module.exports = __webpack_public_path__ + "static/media/smashing-the-ceiling.5137ccbc.svg";